export const FETCH_CAPTCHA = "FETCH_CAPTCHA";
export const SUBMIT_EDM = "SUBMIT_EDM";
export const FETCH_CAPTCHA_CHECK = "FETCH_CAPTCHA_CHECK";
export const FETCH_CHANNEL = "FETCH_CHANNEL";